import React, { useState } from "react";
import { Form, Card, Button, InputNumber, Popconfirm, Space } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import useMessage from "antd/es/message/useMessage";

import { UserService } from "../../../Services/Manage/UserService";
import { ExpenseServices } from "../../../Services/Manage/ExpenseServices";
import GeneralExpenseAdd from "../Expenses/GeneralExpenseAdd";

const CreatePO = ({ open, onClose, getAllExpense }) => {
    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(1);
    const [vendorId, setVendorId] = useState(null);
    const [poId, setPoId] = useState("");
    const [taxId, setTaxId] = useState("");
    const [taxType, setTaxType] = useState("");
    const [message, msgContx] = useMessage();
    const [childForm, setChildForm] = useState(null);

    const handleNewAdd = () => {
        setDataSource([
            ...dataSource,
            { key: count, description: "", qty: 1, unitprice: 0, totalprice: 0, tax_amount: 0 }
        ]);
        setCount(count + 1);
    };

    const handleAdd = (identifier) => {
        const newRow = { key: count, description: "", qty: 1, unitprice: 0, totalprice: 0, tax_amount: 0 };
        const index = dataSource.findIndex((item) => item.id === identifier || item.key === identifier);

        let newData = [...dataSource];
        newData.splice(index + 1, 0, newRow);

        setDataSource(newData);
        setCount(count + 1);
    };

    const handleDelete = async (record) => {
        const newData = dataSource.filter((item) => item.key !== record.key);
        setDataSource(newData);
        message.success("Row deleted");
    };

    const handleChange = (identifier, field, value) => {
        // Handle tax fields separately
        if (field === "tax_id") {
            setTaxId(value);
            return;
        }
        if (field === "tax_type") {
            setTaxType(value);
            return;
        }

        // Handle row-specific fields
        const newData = dataSource.map((item) => {
            if (item.key === identifier || item.id === identifier) {
                const updatedItem = { ...item, [field]: value };

                //  Calculate total = (qty * unitprice) + tax_amount
                const subtotal = (updatedItem.qty || 0) * (updatedItem.unitprice || 0);
                const taxAmount = updatedItem.tax_amount || 0;
                updatedItem.totalprice = subtotal + taxAmount;

                return updatedItem;
            }
            return item;
        });
        setDataSource(newData);
    };

    const handleGeneralSave = async () => {
        try {
            const user = await UserService.getOmeUser();

            const formattedData = dataSource.map(({ key, ...rest }) => ({
                ...rest,
                added_by: user.uid,
                type: "other",
                vendor_id: vendorId,
                po_id: poId,
                tax_id: taxId,
                tax_type: taxType,
            }));

            const request = await ExpenseServices.createExpense(formattedData);

            if (request.status) {
                message.success(request.message);
                handleClose();
                getAllExpense();
            } else {
                message.error(request.message);
            }
        } catch (error) {
            console.error(error);
            message.error("Something went wrong");
        }
    };

    const handleClose = () => {
        onClose();
        setDataSource([]);
        setTaxId("");
        setTaxType("");
        setVendorId(null);

        if (childForm) {
            childForm.resetFields();
        }
    };

    return (
        <div>
            {msgContx}

            <Card>
                <Form layout="vertical">

                    <GeneralExpenseAdd
                        open={open}
                        dataSource={dataSource}
                        setDataSource={setDataSource}
                        handleNewAdd={handleNewAdd}
                        handleAdd={handleAdd}
                        handleDelete={handleDelete}
                        handleChange={handleChange}
                        setVendorId={setVendorId}
                        setPoId={setPoId}
                        setTaxId={setTaxId}
                        setTaxType={setTaxType}
                        onFormReady={setChildForm}
                    />

                    <div style={{ marginTop: 50, display: "flex", justifyContent: "flex-end" }}>
                        <Space>
                            <Button size="large" type="primary" onClick={handleGeneralSave}>
                                Save
                            </Button>
                            <Button size="large" onClick={handleClose}>
                                Cancel
                            </Button>
                        </Space>
                    </div>

                </Form>
            </Card>
        </div>
    );
};

export default CreatePO;
